<template>
    <div class="blogcards-settings">

        <!-- settings group: CONTENT -->
        <div class="settings-group-title">
            <h6>Blogcards display</h6>
        </div>

        <!-- blog cards amount per row tablet -->
        <div class="setting" v-show="deviceStylesSetttings.tabletStyles">
            <b-form-group>

                <label for="blogcard-amountperrow-input">Cards visible per row on tablet:</label>
                
                <b-input-group size="sm">
                    <b-form-input id="blogcard-amountperrow-input" type="number" v-model="settingsFromWeebly.settings.tabletAmountPerRow" min="1" max="25" />
                </b-input-group>

            </b-form-group>
        </div>

        <!-- blog cards amount per row phone -->
        <div class="setting" v-show="deviceStylesSetttings.mobileStyles">
            <b-form-group>

                <label for="blogcard-amountperrow-input">Cards visible per row on phone:</label>
                
                <b-input-group size="sm">
                    <b-form-input id="blogcard-amountperrow-input" type="number" v-model="settingsFromWeebly.settings.phoneAmountPerRow" min="1" max="25" />
                </b-input-group>

            </b-form-group>
        </div>
        
        <div v-show="deviceStylesSetttings.desktopStyles">
            <!-- blog url -->
            <div class="setting">
                <b-form-group>

                    <label for="blogurl-text-input">Blog URL:  <span v-b-tooltip.hover.top title="Make sure to grab the correct url from your blog page found in the address bar on your live site"><i class="far fa-question-circle"></i></span></label>

                    <b-form-input id="blogurl-text-input" type="text" v-model="settingsFromWeebly.settings.blogUrl" size="sm" />

                </b-form-group>
            </div>

            <!-- blog cards amount -->
            <div class="setting">
                <b-form-group>

                    <label for="blogcard-amount-input">Total amount of blog cards:   <span v-b-tooltip.hover.top title="You can only collect up to a maximum of 25 blog posts, make sure your setting in Weebly for blog displayed per page is set to the same or higher amount than this setting "><i class="far fa-question-circle"></i></span></label>
                    
                    <b-input-group size="sm">
                        <b-form-input id="blogcard-amount-input" type="number" v-model="settingsFromWeebly.settings.blogCardsAmount" min="1" max="25" />
                    </b-input-group>

                </b-form-group>
            </div>
        </div>

        <!-- blog cards amount per row desktop -->
        <div v-show="deviceStylesSetttings.desktopStyles">
            <div class="setting">
                <b-form-group>

                    <label for="blogcard-amountperrow-input">Cards visible per row on desktop:</label>
                    
                    <b-input-group size="sm">
                        <b-form-input id="blogcard-amountperrow-input" type="number" v-model="settingsFromWeebly.settings.desktopAmountPerRow" min="1" max="25" />
                    </b-input-group>

                </b-form-group>
            </div>

            <!-- settings group: CONTENT -->
            <div class="settings-group-title">
                <h6>Blogcards title</h6>
            </div>

            <!-- font family -->
            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !settingsFromWeebly.settings.useCustomFont">
                <b-form-group>
                    <div style="display: flex">
                        <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                        <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                    </div>
                    <b-form-select :options="googleFontsArray" @change="applyFont" v-model="settingsFromWeebly.settings.fontGoogleLoad" size="sm" />
                </b-form-group>
            </div>

            <!-- custom font family -->
            <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.useCustomFont" name="use-custom-font">
                    Use custom font
                </b-form-checkbox>
            </div>

            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useCustomFont" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                <b-form-group>

                    <div class="setting">
                        <label for="button-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                        <b-form-input id="button-customFontName" type="text" v-model="settingsFromWeebly.settings.customFontName" size="sm" />
                    </div>

                    <div class="setting">
                        <label for="button-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                        <b-form-select id="button-customFontWeight" v-model="settingsFromWeebly.settings.customFontWeight" size="sm">
                            <option value="100">Thin - 100</option>
                            <option value="200">Extra-LIght - 200</option>
                            <option value="300">Light - 300</option>
                            <option value="400">Regular - 400</option>
                            <option value="500">Medium - 500</option>
                            <option value="600">Semi-Bold - 600</option>
                            <option value="700">Bold - 700</option>
                            <option value="800">Extra-Bold - 800</option>
                            <option value="900">Black - 900</option>
                        </b-form-select>

                    </div>

                    <div class="setting">
                        <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                        <b-form-select id="button-customFontStyle" v-model="settingsFromWeebly.settings.customFontStyle" size="sm">
                            <option value="normal">Normal</option>
                            <option value="italic">Italic</option>
                        </b-form-select>
                    </div>

                </b-form-group>
            </div>

            <!-- font size card title -->
            <div class="setting">
                <b-form-group>

                    <label for="button-fontsizeTitle-input">Font size:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="button-fontsizeTitle-input" type="number" v-model="settingsFromWeebly.settings.cardTitleFontSize" min="5" step="1" />
                    </b-input-group>

                </b-form-group>
            </div>

            <!-- line height card text -->
            <div class="setting">
                <b-form-group>

                    <label for="blogcard-lineHeightTitle-input">Line height:</label>
                    
                    <b-input-group size="sm" append="em">
                        <b-form-input id="blogcard-lineHeightTitle-input" type="number" v-model="settingsFromWeebly.settings.lineHeightTitle" min="1" max="3" step="0.1" />
                    </b-input-group>

                </b-form-group>
            </div>

            <!-- card title color -->
            <div class="setting">
                <Mycolorpicker elementRef="blogcardTitleColor" theColorPicker="allpickers" colorPickerName="Card title color:" />
            </div>

            <!-- settings group: CONTENT -->
            <div class="settings-group-title">
                <h6>Blogcards text</h6>
            </div>

            <!-- font family -->
            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !settingsFromWeebly.settings.useCustomFontText">
                <b-form-group>
                    <div style="display: flex">
                        <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                        <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                    </div>
                    <b-form-select :options="googleFontsArray" @change="applyFontText" v-model="settingsFromWeebly.settings.fontGoogleLoadText" size="sm" />
                </b-form-group>
            </div>

            <!-- custom font family -->
            <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.useCustomFontText" name="use-custom-font">
                    Use custom font
                </b-form-checkbox>
            </div>

            <div class="setting" v-show="deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useCustomFontText" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                <b-form-group>

                    <div class="setting">
                        <label for="button-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                        <b-form-input id="button-customFontName" type="text" v-model="settingsFromWeebly.settings.customFontNameText" size="sm" />
                    </div>

                    <div class="setting">
                        <label for="button-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                        <b-form-select id="button-customFontWeight" v-model="settingsFromWeebly.settings.customFontWeightText" size="sm">
                            <option value="100">Thin - 100</option>
                            <option value="200">Extra-LIght - 200</option>
                            <option value="300">Light - 300</option>
                            <option value="400">Regular - 400</option>
                            <option value="500">Medium - 500</option>
                            <option value="600">Semi-Bold - 600</option>
                            <option value="700">Bold - 700</option>
                            <option value="800">Extra-Bold - 800</option>
                            <option value="900">Black - 900</option>
                        </b-form-select>

                    </div>

                    <div class="setting">
                        <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                        <b-form-select id="button-customFontStyle" v-model="settingsFromWeebly.settings.customFontStyleText" size="sm">
                            <option value="normal">Normal</option>
                            <option value="italic">Italic</option>
                        </b-form-select>
                    </div>

                </b-form-group>
            </div>

            <!-- font size card text -->
            <div class="setting">
                <b-form-group>

                    <label for="button-fontsize-input">Font size:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="button-fontsize-input" type="number" v-model="settingsFromWeebly.settings.cardTextFontSize" min="5" step="1" />
                    </b-input-group>

                </b-form-group>
            </div>

            <!-- line height card text -->
            <div class="setting">
                <b-form-group>

                    <label for="blogcard-lineHeight-input">Line height:</label>
                    
                    <b-input-group size="sm" append="em">
                        <b-form-input id="blogcard-lineHeight-input" type="number" v-model="settingsFromWeebly.settings.lineHeightText" min="1" max="3" step="0.1" />
                    </b-input-group>

                </b-form-group>
            </div>

            <!-- card text color -->
            <div class="setting">
                <Mycolorpicker elementRef="blogcardTextColor" theColorPicker="allpickers" colorPickerName="Card text color:" />
            </div>

            <!-- text amounts lines -->
            <div class="setting">
                <b-form-group>

                    <label for="blogcard-amount-input">Text lines visible:</label>
                    
                    <b-input-group size="sm">
                        <b-form-input id="blogcard-amount-input" type="number" v-model="settingsFromWeebly.settings.showLinesOfText" min="1" max="25" />
                    </b-input-group>

                </b-form-group>
            </div>

            <!-- cards read more icon -->
            <div class="settings-group-title">
                <h6>Read more icon</h6>
            </div>

            <!-- readmore bg -->
            <div class="setting">
                <Mycolorpicker elementRef="readmoreBg" theColorPicker="allpickers" colorPickerName="Read more icon background:" />
            </div>

            <!-- readmore bg hover-->
            <div class="setting">
                <Mycolorpicker elementRef="readmoreBgHover" theColorPicker="allpickers" colorPickerName="Read more icon background on hover:" />
            </div>

            <!-- readmore color -->
            <div class="setting">
                <Mycolorpicker elementRef="readmoreColor" theColorPicker="allpickers" colorPickerName="Read more icon color:" />
            </div>

            <!-- readmore color hover -->
            <div class="setting">
                <Mycolorpicker elementRef="readmoreColorHover" theColorPicker="allpickers" colorPickerName="Read more icon color on hover:" />
            </div>

        </div><!-- desktop and global settings -->

        <!-- settings group: CONTENT -->
        <div class="settings-group-title">
            <h6>Blogcards styles</h6>
        </div>
        
        <div v-show="deviceStylesSetttings.desktopStyles">
            <!-- card bg -->
            <div class="setting">
                <Mycolorpicker elementRef="cardBg" theColorPicker="allpickers" colorPickerName="Background color card:" />
            </div>

            <!-- border color card -->
            <div class="setting">
                <Mycolorpicker elementRef="cardBorderColor" theColorPicker="allpickers" colorPickerName="Border color card:" />
            </div>

            <!-- image wrapper height desktop -->
            <div class="setting">
                <b-form-group>

                    <label for="button-cardImageHeightDesktop-input">Image wrapper height:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="button-cardImageHeightDesktop-input" type="number" v-model="settingsFromWeebly.settings.cardImageHeightDesktop" min="0" step="10" />
                    </b-input-group>

                </b-form-group>
            </div>

            <!-- use rounded border -->
            <div class="setting">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.useRoundedEdge" name="use-useRoundedEdge-font">
                    Use rounded edge
                </b-form-checkbox>
            </div>
            
        </div>

        <div v-show="deviceStylesSetttings.tabletStyles">
            <!-- image wrapper height tablet -->
            <div class="setting">
                <b-form-group>

                    <label for="button-cardImageHeightTablet-input">Image wrapper height:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="button-cardImageHeightTablet-input" type="number" v-model="settingsFromWeebly.settings.cardImageHeightTablet" min="0" step="10" />
                    </b-input-group>

                </b-form-group>
            </div>
        </div>

        <div v-show="deviceStylesSetttings.mobileStyles">
            <!-- image wrapper height tablet -->
            <div class="setting">
                <b-form-group>

                    <label for="button-cardImageHeightPhone-input">Image wrapper height:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="button-cardImageHeightPhone-input" type="number" v-model="settingsFromWeebly.settings.cardImageHeightPhone" min="0" step="10" />
                    </b-input-group>

                </b-form-group>
            </div>
        </div>
        

        <!-- card filters -->
        <div v-show="deviceStylesSetttings.desktopStyles">    
            <!-- settings group: CONTENT -->
            <div class="settings-group-title">
                <h6>Blogcards filter</h6>
            </div>

            <!-- use filter blogs -->
            <div class="setting">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.useFiltering" name="use-custom-font">
                    Use blog card filtering
                </b-form-checkbox>
            </div>

            <div v-if="settingsFromWeebly.settings.useFiltering">

                <!-- align button DESKTOP -->
                <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                    <label for="">Filter align:</label>
                    <b-form-radio-group buttons class="alignment-radios" size="md" v-model="settingsFromWeebly.settings.filterAlignement">
                        <b-form-radio value="left"  name="desktop-button-aligment"><i class="fas fa-align-left"></i></b-form-radio>
                        <b-form-radio value="center"  name="desktop-button-aligment"><i class="fas fa-align-center"></i></b-form-radio>
                        <b-form-radio value="right"  name="desktop-button-aligment"><i class="fas fa-align-right"></i></b-form-radio>
                    </b-form-radio-group>
                </div>

                <!-- font family -->
                <div class="setting" v-show="deviceStylesSetttings.desktopStyles && !settingsFromWeebly.settings.useCustomFontFilter">
                    <b-form-group>
                        <div style="display: flex">
                            <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                            <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                        </div>
                        <b-form-select :options="googleFontsArray" @change="applyFontText" v-model="settingsFromWeebly.settings.fontGoogleLoadFilter" size="sm" />
                    </b-form-group>
                </div>

                <!-- custom font family -->
                <div class="setting" v-show="deviceStylesSetttings.desktopStyles">
                    <b-form-checkbox switch v-model="settingsFromWeebly.settings.useCustomFontFilter" name="use-custom-font">
                        Use custom font
                    </b-form-checkbox>
                </div>

                <div class="setting" v-show="deviceStylesSetttings.desktopStyles && settingsFromWeebly.settings.useCustomFontFilter" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                    <b-form-group>

                        <div class="setting">
                            <label for="button-customFontNameFilter">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                            <b-form-input id="button-customFontNameFilter" type="text" v-model="settingsFromWeebly.settings.customFontNameFilter" size="sm" />
                        </div>

                        <div class="setting">
                            <label for="button-customFontWeightFilter">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                            <b-form-select id="button-customFontWeightFilter" v-model="settingsFromWeebly.settings.customFontWeightFilter" size="sm">
                                <option value="100">Thin - 100</option>
                                <option value="200">Extra-LIght - 200</option>
                                <option value="300">Light - 300</option>
                                <option value="400">Regular - 400</option>
                                <option value="500">Medium - 500</option>
                                <option value="600">Semi-Bold - 600</option>
                                <option value="700">Bold - 700</option>
                                <option value="800">Extra-Bold - 800</option>
                                <option value="900">Black - 900</option>
                            </b-form-select>

                        </div>

                        <div class="setting">
                            <label for="button-customFontStyleFilter">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                            <b-form-select id="button-customFontStyleFilter" v-model="settingsFromWeebly.settings.customFontStyleFilter" size="sm">
                                <option value="normal">Normal</option>
                                <option value="italic">Italic</option>
                            </b-form-select>
                        </div>

                    </b-form-group>
                </div>

                <!-- font size filter text -->
                <div class="setting">
                    <b-form-group>

                        <label for="button-fontsizeFilter-input">Font size:</label>
                        
                        <b-input-group append="px" size="sm">
                            <b-form-input id="button-fontsizeFilter-input" type="number" v-model="settingsFromWeebly.settings.cardFilterFontSize" min="5" step="1" />
                        </b-input-group>

                    </b-form-group>
                </div>

                <!-- filterItemColor -->
                <div class="setting">
                    <Mycolorpicker elementRef="filterItemColor" theColorPicker="allpickers" colorPickerName="Text color:" />
                </div>

                <!-- filterItemColorHover -->
                <div class="setting">
                    <Mycolorpicker elementRef="filterItemColorHover" theColorPicker="allpickers" colorPickerName="Text color hover/active:" />
                </div>

                <!-- filterItemBg -->
                <div class="setting">
                    <Mycolorpicker elementRef="filterItemBg" theColorPicker="allpickers" colorPickerName="Background:" />
                </div>

                <!-- filterItemBgHover -->
                <div class="setting">
                    <Mycolorpicker elementRef="filterItemBgHover" theColorPicker="allpickers" colorPickerName="Background hover/active:" />
                </div>

                <!-- filterItemBorderColor -->
                <div class="setting">
                    <Mycolorpicker elementRef="filterItemBorderColor" theColorPicker="allpickers" colorPickerName="Border color:" />
                </div>

                <!-- filterItemBorderColorHover -->
                <div class="setting">
                    <Mycolorpicker elementRef="filterItemBorderColorHover" theColorPicker="allpickers" colorPickerName="Border color hover:" />
                </div>

            </div>
        </div>

        

    </div>
</template>

<script>

import Mycolorpicker from './Mycolorpicker'

export default {

    name: 'BlogcardsSettings',

    data() {
        return {
            errorInString: false
        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },

        // google font picker
        googleFontsArray() {
            return this.$store.state.googleFontsToLoad
        }

    },

    mounted() {

    },

    components: {
        Mycolorpicker
    },

    methods: {
        // apply font in css
        applyFont() {

            console.log(event.target.value)

            let font = event.target.value

            // load google font
            this.$store.state.weeblySettings.settings.fontGoogleLoad = font

            // convert font that equals id for checking checkbox
            font = font.split(':')

            let fontNameSplit = font[0]

            // remove possible + instances from fontNameSplit string
            if(fontNameSplit.includes('+')) {
                fontNameSplit = fontNameSplit.replace(/\+/g, " ")
                this.$store.state.weeblySettings.settings.fontFamily = '"'+fontNameSplit+'"'
            } else {
                this.$store.state.weeblySettings.settings.fontFamily = fontNameSplit
            }
            
            let fontStylePart = font[1]

            if( fontStylePart.includes('i') ) {
                let fontStylePartSplit = fontStylePart.split(/(i)/g)
                this.$store.state.weeblySettings.settings.fontStyle = 'italic'
                this.$store.state.weeblySettings.settings.fontWeight = fontStylePartSplit[0]
            } else {
                this.$store.state.weeblySettings.settings.fontWeight = fontStylePart
                this.$store.state.weeblySettings.settings.fontStyle = 'normal'
            }

        },

        // apply font in css
        applyFontText() {

            console.log(event.target.value)

            let font = event.target.value

            // load google font
            this.$store.state.weeblySettings.settings.fontGoogleLoadText = font

            // convert font that equals id for checking checkbox
            font = font.split(':')

            let fontNameSplit = font[0]

            // remove possible + instances from fontNameSplit string
            if(fontNameSplit.includes('+')) {
                fontNameSplit = fontNameSplit.replace(/\+/g, " ")
                this.$store.state.weeblySettings.settings.fontFamilyText = '"'+fontNameSplit+'"'
            } else {
                this.$store.state.weeblySettings.settings.fontFamilyText = fontNameSplit
            }
            
            let fontStylePart = font[1]

            if( fontStylePart.includes('i') ) {
                let fontStylePartSplit = fontStylePart.split(/(i)/g)
                this.$store.state.weeblySettings.settings.fontStyleText = 'italic'
                this.$store.state.weeblySettings.settings.fontWeightText = fontStylePartSplit[0]
            } else {
                this.$store.state.weeblySettings.settings.fontWeightText = fontStylePart
                this.$store.state.weeblySettings.settings.fontStyleText = 'normal'
            }

        },

        isAlpha() {
            console.log(event.target.value)
            let yourString = event.target.value
            if(/^[a-zA-Z()]+$/.test(event.target.value)){
                console.log('we are good')
                this.errorInString = false
            } else {
                console.log('characater can not be used')
                this.errorInString = true
                // return event.target.value = /^[a-zA-Z()]+$/.test(event.target.value)
            }

        }

        
    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';
.errordisplay {
    border: 1px solid @warning_red;
    font-size: 12px;
    padding: 7px;
    font-weight: 700;
    border-radius: .25rem;
    margin: 7px auto;

    h2 {
        font-size: 14px;
    }

    span {
        font-style: italic;
        display: block;
        margin-top: 7px;
        color: @warning_red;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/BlogcardsSettings.vue